import { render, staticRenderFns } from "./NewComposer.vue?vue&type=template&id=684927ee&scoped=true&"
import script from "./NewComposer.vue?vue&type=script&lang=js&"
export * from "./NewComposer.vue?vue&type=script&lang=js&"
import style0 from "./NewComposer.vue?vue&type=style&index=0&id=684927ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684927ee",
  null
  
)

export default component.exports